const MicroModal = require('micromodal'); // commonjs module
const modals = document.querySelectorAll('.modal');

if (modals) {
    MicroModal.init();
}
